var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesplegable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34pt",
    height: "33pt",
    viewBox: "0 0 34 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "cp0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,33)",
    d: "M 12.25722 11.70023 L 10.80413 13.10079 L 17.18394 19.71985 L 23.80214 13.32833 L 22.40015 11.87662 L 17.23509 16.86477 L 12.25722 11.70023 Z ",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp0)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,33)",
    d: "M -316 -537 L 59 -537 L 59 481 L -316 481 Z "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,33)",
    d: "M 28.91354 6.989546 L 5.917048 6.58814 L 5.604072 24.51849 L 28.60057 24.91989 Z "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesplegable);
export default __webpack_public_path__ + "static/media/desplegable.686f7095.svg";
export { ForwardRef as ReactComponent };